import { StatusVm } from "./StatusVm";
import { OfficerVm } from "./OfficerVm";
import { AuthorityVm } from "./AuthorityVm";

export class ControlCardVm{
    Id: number = 0;
    CardDataId = 0;
    CardNumber: string = "";
    ValidTo: Date | null = null;
    ValidFrom: Date  | null = null;
    Status: StatusVm = new StatusVm();
    CardOwnerName: string = "";
    CardOwnerAddress: string = "";
    Officer: OfficerVm  = new OfficerVm();
    Authority: AuthorityVm = new AuthorityVm();
}